<template>
    <b-overlay :show="loading">
        <b-row class="justify-content-center">
            <b-col sm="12" md="10">
                <form-tanggal @submit="submit"></form-tanggal>
                <b-card v-if="profitLossContent">
                    <div class="d-flex justify-content-end mb-2">
                        <b-dropdown
                            variant="outline-primary"
                            text="Download"
                            right
                            :disabled="!profitLossContent"
                        >
                            <b-dropdown-item href="#" @click.prevent="download('pdf')">
                                Export ke PDF
                            </b-dropdown-item>
                            <b-dropdown-item href="#" @click.prevent="download('excel')">
                                Export ke Excel
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <section id="table-content" v-html="profitLossContent"></section>
                </b-card>
                <div class="alert alert-danger p-1" v-else>
                    Harap pilih tanggal awal & tanggal akhir
                </div>
            </b-col>
        </b-row>
    </b-overlay>
</template>
<script>
import {
  BOverlay, BRow, BCol, BCard, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import FormTanggal from './components/FormTanggal'
import service from '@/services'

export default {
  components: {
    FormTanggal,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BDropdown,
    BDropdownItem,
  },
  data: () => ({
    loading: false,
    form: {
      tgl_awal: null,
      tgl_akhir: null,
    },
    profitAndLoss: null,
    profitLossContent: null,
  }),
  methods: {
    parseFilename(disposition, fallback) {
      if (!disposition) return fallback
      const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      if (utfMatch && utfMatch[1]) {
        try {
          return decodeURIComponent(utfMatch[1])
        } catch (e) {
          return utfMatch[1]
        }
      }
      const match = disposition.match(/filename="?([^";]+)"?/i)
      return match && match[1] ? match[1] : fallback
    },
    openBlob(blob, filename, typeExport) {
      const url = URL.createObjectURL(blob)
      if (typeExport === 'excel') {
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(url), 1000)
        return
      }
      window.open(url)
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    },
    async download(typeExport) {
      if (!this.profitLossContent) {
        this.displayError({
          message: 'Harap klik lihat laporan terlebih dahulu sebelum download',
        })
        return false
      }
      if (!this.form.tgl_awal || !this.form.tgl_akhir) {
        this.displayError({
          message: 'Harap isi tanggal awal dan akhir!',
        })
        return false
      }

      try {
        this.loading = true
        const config = {
          method: 'get',
          url: this.$route.meta.api || '/cetak-laba-rugi',
          params: {
            tgl_awal: this.form.tgl_awal,
            tgl_akhir: this.form.tgl_akhir,
            type_export: typeExport,
          },
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
          responseType: 'blob',
        }
        const response = await service.sendRequest(config)
        this.loading = false
        const fallback = typeExport === 'pdf'
          ? 'Laporan Laba Rugi.pdf'
          : 'Laporan Laba Rugi.xlsx'
        const filename = this.parseFilename(
          response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']),
          fallback,
        )
        this.openBlob(response.data, filename, typeExport)
      } catch (e) {
        this.loading = false
        if (e.response && e.response.data instanceof Blob) {
          try {
            const text = await e.response.data.text()
            this.displayError(JSON.parse(text))
            return false
          } catch (parseErr) {
            this.displayError(e)
            return false
          }
        }
        this.displayError(e)
        return false
      }
    },
    async submit({ tgl_awal, tgl_akhir }) {
      try {
        this.loading = true
        this.form.tgl_awal = tgl_awal
        this.form.tgl_akhir = tgl_akhir
        const params = { tgl_awal, tgl_akhir }
        this.profitLossContent = null
        const result = await this.$store.dispatch('laporan/getProfitAndLoss', params)
        let content = `
                    <table border="1" id="profit-loss-table" class="table table-bordered">
                        <tr>
                            <th colspan="2"><h5>Periode</h5></th>
                            <th align="right">Dari ${this.form.tgl_awal} sampai dengan ${this.form.tgl_akhir}</th>
                        </tr>
                    `
        result.data.map(item => {
          if (item.ketagori || item.kategori) {
            content += `<tr>
                            <th colspan="3">${item.kategori ? item.kategori : null}</th>
                        </tr>    `
          }

          if (item.detail && item.detail.length > 0) {
            item.detail.map(detail => {
              content += '<tr>'
              content += `<td>${detail.nomor ? detail.nomor : null}</td>`
              content += `<td>${detail.akun ? detail.akun : null}</td>`
              content += `<td align="right">${detail.total ? detail.total : null}</td>`
              content += '</tr>'
            })
          }

          content += `<tr>
                        <th colspan="2" align="left">${item.keterangan ? item.keterangan : null}</th>
                        <th class="text-right" align="right">${item.total ? item.total : null}</th>
                    </tr>`
        })

        if (result.info) {
          content += `<tr>
                        <th colspan="2">Laba/Rugi Bersih Sebelum Pajak</th>
                        <th class="text-right">${result.info.totalTanpaPajak}</th>
                    </tr>`
          if (result.info.pajak) {
            content += `<tr>
                            <td>${result.info.pajak.nomor}</td>
                            <td>${result.info.pajak.kategori}</td>
                                <td class="text-right">${result.info.totalPajak}</td>
                            </tr>`
          }

          content += `<tr>
                    <th colspan="2">Laba/Rugi Bersih Setelah Pajak</th>
                    <th class="text-right">${result.info.totalDenganPajak}</th>
                    </tr>`
        }
        this.profitLossContent = content
        this.loading = false
      } catch (e) {
        this.loading = false
        this.displayError(e)
        return false
      }
    },
  },
}
</script>
<style>
    #profit-loss-table tr:nth-child(even) {
        background-color: #bedbff;
    }

    #profit-loss-table, #profit-loss-table th, #profit-loss-table td  {
        border: 1px solid #333;
    }

    .dark-layout #profit-loss-table tr:nth-child(even) {
        background-color: transparent;
    }

    .dark-layout #profit-loss-table,
    .dark-layout #profit-loss-table th,
    .dark-layout #profit-loss-table td {
        border-color: #6e6b7b;
    }
</style>
